import Vue from 'vue';
import Inventory from '@/models/Inventory';
import { getRequest } from '@/api';
import { INVENTORY_MUTATIONS } from '@/store/mutation-types';
import _ from 'lodash';

export const state = () => ({
  inventory: new Inventory(),
  discounts: {},
  inventoryPending: false,
  inventoryError: null,
});

const fetchPacketsDebounced = _.debounce(getRequest, 200);
export const actions = {
  fetchPackets({ commit, getters }) {
    if (getters.empty) {
      fetchPacketsDebounced('/products/packets', INVENTORY_MUTATIONS, commit);
    }
  },
  applyPacketDiscounts({ commit, dispatch }, discounts) {
    commit('applyPacketDiscounts', discounts);
    commit(INVENTORY_MUTATIONS.SUCCESS, {});
    dispatch('fetchPackets');
  },
  clearDiscounts({ commit, dispatch }) {
    commit('clearDiscounts');
    commit(INVENTORY_MUTATIONS.SUCCESS, {});
    dispatch('fetchPackets');
  },
};

export const mutations = {
  [INVENTORY_MUTATIONS.SUCCESS]: (state, packets) =>
    Vue.set(state, 'inventory', new Inventory(packets, state.discounts)),
  [INVENTORY_MUTATIONS.PENDING]: (state, pending) =>
    (state.inventoryPending = pending),
  [INVENTORY_MUTATIONS.FAILURE]: (state, error) =>
    (state.inventoryError = error),
  applyPacketDiscounts: (state, discounts) => (state.discounts = discounts),
  clearDiscounts: state => (state.discounts = {}),
};

export const getters = {
  getUnlimitedPackets: state => serviceClass =>
    state.inventory.getPackets(serviceClass, 'unlimited'),

  getDataPackets: state => serviceClass =>
    state.inventory.getPackets(serviceClass, 'data'),

  empty: state => state.inventory.empty(),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
